var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { omit } from "lodash-es";
import Component from 'vue-class-component';
import { Inject, Vue } from 'vue-property-decorator';
let StylePanelMixin = class StylePanelMixin extends Vue {
  get style() {
    return this.stylePanel.style;
  }
  set style(val) {
    this.stylePanel.style = val;
  }
  deleteStyle(key) {
    this.style = omit(this.style, [key]);
  }
  setStyle(key, value) {
    this.style = {
      ...this.style,
      [key]: value
    };
  }
  changeAndDelete(key, value) {
    const oldValue = this.style[key];
    if (value === oldValue) {
      this.deleteStyle(key);
    } else {
      this.setStyle(key, value);
    }
  }
  changedFromDefault(key, value, cssObj = this.style) {
    return !!cssObj[key] && cssObj[key] !== value;
  }
  get hoverStyle() {
    return this.stylePanel.defaultHoverStyle;
  }
  set hoverStyle(value) {
    this.stylePanel.defaultHoverStyle = value;
  }
  changeHover(key, value) {
    this.hoverStyle = {
      ...this.hoverStyle,
      [key]: value
    };
  }
  changeAndDeleteHover(key, value) {
    const oldValue = this.hoverStyle[key];
    if (value === oldValue) {
      this.hoverStyle = omit(this.hoverStyle, [key]);
    } else {
      this.hoverStyle = {
        ...this.hoverStyle,
        [key]: value
      };
    }
  }
};
__decorate([Inject({
  from: 'stylePanel'
})], StylePanelMixin.prototype, "stylePanel", void 0);
StylePanelMixin = __decorate([Component], StylePanelMixin);
export default StylePanelMixin;
//# sourceMappingURL=StylePanelMixin.js.map
